/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { FETCH_STATUSES } from 'utils/fetchStatusUtils';
import RealEstateAgentsRepository from 'repositories/public/RealEstateAgentsRepository';

const initialState = {
  realEstateAgent: null,
  realEstateAgentLoadingStatus: FETCH_STATUSES.idle,
};

const publicRealEstateAgentSlice = createSlice({
  name: 'publicRealEstateAgentSlice',
  initialState,
  reducers: {
    loadRealEstateAgentStart(state) {
      state.realEstateAgentLoadingStatus = FETCH_STATUSES.pending;
    },
    loadRealEstateAgentSuccess(state, { payload }) {
      const { realEstateAgent } = payload;
      state.realEstateAgent = realEstateAgent;
      state.realEstateAgentLoadingStatus = FETCH_STATUSES.fulfilled;
    },
    loadRealEstateAgentFail(state) {
      state.realEstateAgentLoadingStatus = FETCH_STATUSES.failed;
    },
  },
});

export const { actions } = publicRealEstateAgentSlice;

export default publicRealEstateAgentSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const loadRealEstateAgent = async slug => {
    dispatch(actions.loadRealEstateAgentStart());
    try {
      const { realEstateAgent } = await RealEstateAgentsRepository.show(slug);
      dispatch(actions.loadRealEstateAgentSuccess({ realEstateAgent }));
    } finally {
      dispatch(actions.loadRealEstateAgentFail());
    }
  };

  return {
    loadRealEstateAgent,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/public/realEstateAgentsSlice.js